<template>
  <div class="login-layout">
    <div class="login-center">
      <!-- LOGIN FORM -->
      <div class="PrviBlock" style="text-align: center;">
        <!-- LOGO-->
        <img src="../../public/img/baner2.png" width="300px" alt="Baner" class="logo" />
      </div>
      <div class="DrugiBlock">
        <form @submit.prevent="handleLogin">
          <div>
            <label for="username" class="form-label">
              {{ $t('login.username') }}
            </label>
            <input v-model="username" type="text" class="form-control" id="username" autocomplete="username" required />
          </div>
          <div>
            <label for="password" class="form-label">
              {{ $t('login.password') }}
            </label>
            <div class="password-wrapper">
              <input v-model="password" :type="showPassword ? 'text' : 'password'" class="form-control password-input"
                id="password" autocomplete="current-password" required />
              <button type="button" class="password-toggle" @click="showPassword = !showPassword">
                <span class="mdi" :class="showPassword ? 'mdi-eye-off' : 'mdi-eye'" style="font-size: 20px;"></span>
              </button>
            </div>
          </div>
          <button type="submit" class="btn-prijava">
            {{ $t('login.button') }}
          </button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { useI18n } from 'vue-i18n'
import { useAuth } from '@/composables/useAuth'

export default {
  name: "LoginPage",
  setup() {
    const showPassword = ref(false)
    const username = ref('')
    const password = ref('')
    const error = ref(false)
    const router = useRouter()
    const auth = useAuth()
    const store = useStore()
    const { t } = useI18n()

    const handleLogin = async () => {
      error.value = false
      const success = await auth.login(username.value.trim(), password.value.trim())

      if (success === true) {
        await router.push('/home')
      }
      else if (success === 'company_stopped') {
        error.value = true
        store.dispatch('NOTIF_WARNING', {
          poruka: t('User_message.m143'),
          position: 'top-end',
          icon: 'error',
          timer: 4500,
          width: '550'
        })
      }
      else if (success === 'client_stopped') {
        error.value = true
        store.dispatch('NOTIF_WARNING', {
          poruka: t('User_message.m132'),
          position: 'top-end',
          icon: 'error',
          timer: 4500,
          width: '550'
        })
      } else {
        error.value = true
        store.dispatch('NOTIF_WARNING', {
          poruka: t('User_message.m127'),
          position: 'top-end',
          icon: 'error',
          timer: 4500,
          width: '550'
        })
      }
    }

    return {
      username,
      password,
      error,
      showPassword,
      handleLogin,
      t
    }
  }
};
</script>

<style scoped>
/* Generalni stilovi */
.login-layout {
  min-height: 100vh;
  width: 100vw;
  background-color: transparent !important;
  background-image: linear-gradient(180deg, #0C629C, #278DCC);
}

.login-center {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  /* horizontalno */
  align-items: center;
  /* vertikalno */
}

.PrviBlock {
  width: 400px;
  padding: 30px;
  background-image: url('/public/img/prviBlock.png');
  background-color: rgba(255, 255, 255, 0.95);
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15);
  font-family: 'Segoe UI', sans-serif;
}

.DrugiBlock {
  width: 400px;
  padding: 20px;
  background-color: rgba(255, 255, 255, 0.95);
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15);
  font-family: 'Segoe UI', sans-serif;
}

.login-title {
  text-align: center;
  margin-bottom: 10px;
  font-weight: 500;
  font-size: 24px;
}

.btn-prijava {
  width: 100%;
  padding: 10px;
  font-size: 16px;
  background-color: #2886C7;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.2s ease-in-out;
  margin-top: 15px;
}

.btn-prijava:hover {
  background-color: #1875B5;
}

.form-label {
  display: block;
  margin-bottom: 6px;
  font-weight: 500;
}

.form-control {
  width: 100%;
  padding: 10px 12px;
  font-size: 14px;
  border: 1px solid #ccc;
  border-radius: 6px;
  box-sizing: border-box;
  margin-bottom: 16px;
}

.password-wrapper {
  position: relative;
  margin-bottom: 16px;
}

.password-wrapper .form-control {
  margin-bottom: 0 !important;
  padding-right: 42px !important;
  width: 100%;
}

.password-toggle {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  color: #777;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
}

.password-toggle:hover {
  color: #2886C7;
}

.password-toggle:focus {
  outline: none;
}
</style>